<template>
    <div class="shadow-block">
        <slot></slot>
    </div>
</template>

<style>
.shadow-block{
    padding: 12px 16px;
    border-radius: 6px;
    box-shadow: 0px 2px 24px 0px #001D6614;
}
</style>